/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} RegisteredInputs */

const en_registered = /** @type {(inputs: RegisteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registered`)
};

const fr_registered = /** @type {(inputs: RegisteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistré`)
};

const de_registered = /** @type {(inputs: RegisteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eingetragen`)
};

const it_registered = /** @type {(inputs: RegisteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registrato`)
};

const ru_registered = /** @type {(inputs: RegisteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Зарегистрировано`)
};

const es_registered = /** @type {(inputs: RegisteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registrado`)
};

const zh_cn2_registered = /** @type {(inputs: RegisteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`挂号的`)
};

const ja_registered = /** @type {(inputs: RegisteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`登録済み`)
};

const hi_registered = /** @type {(inputs: RegisteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`दर्ज कराई`)
};

const pt_pt2_registered = /** @type {(inputs: RegisteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registrado`)
};

/**
* | output |
* | --- |
* | "Registered" |
*
* @param {RegisteredInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const registered = /** @type {((inputs?: RegisteredInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<RegisteredInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_registered(inputs)
	if (locale === "de") return de_registered(inputs)
	if (locale === "it") return it_registered(inputs)
	if (locale === "ru") return ru_registered(inputs)
	if (locale === "es") return es_registered(inputs)
	if (locale === "zh-CN") return zh_cn2_registered(inputs)
	if (locale === "ja") return ja_registered(inputs)
	if (locale === "hi") return hi_registered(inputs)
	if (locale === "pt-PT") return pt_pt2_registered(inputs)
	return en_registered(inputs)
});